module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title16"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Table of Contents")])]), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    attrs: {
      "id": "title16"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781439633861_tp01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781439633861_cop01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_dedicationPage",
    attrs: {
      "href": "#/e9781439633861_ded01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Dedication")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781439633861_fm02"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("INTRODUCTION")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439633861_c01"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("One")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE NEW YORK AND QUEENS COUNTY RAILWAY")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439633861_c02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Two")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE MANHATTAN AND QUEENS TRACTION")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439633861_c03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Three")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE NEW YORK AND NORTH SHORE TRACTION RAILWAY")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439633861_c04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Four")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE TROLLEYS THAT MET ALL THE TRAINS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439633861_c05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Five")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE SOUTH SHORE LINES AND A SURPRISE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439633861_c06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Six")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE NEW YORK AND LONG ISLAND TRACTION COMPANY")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439633861_c07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Seven")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE LONG ISLAND ELECTRIC RAILWAY")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439633861_c08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Eight")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE SURVIVORS STEINWAY AND JAMAICA CENTRAL")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439633861_c09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Nine")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE SAGA OF THE ROCKAWAYS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439633861_c10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Ten")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("FINISHING THE STORY")])])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e961e92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439633861_toc01.vue
// module id = 69
// module chunks = 0